import { render, staticRenderFns } from "./CardOrdine.vue?vue&type=template&id=74fa873f"
import script from "./CardOrdine.vue?vue&type=script&lang=ts"
export * from "./CardOrdine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fa873f')) {
      api.createRecord('74fa873f', component.options)
    } else {
      api.reload('74fa873f', component.options)
    }
    module.hot.accept("./CardOrdine.vue?vue&type=template&id=74fa873f", function () {
      api.rerender('74fa873f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardOrdine.vue"
export default component.exports